module.exports = __webpack_public_path__ + "static/05-thumb-0ed9c07c9de861ad547cef4d16cf2c31.jpg";